import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import CreateAccount from './createaccount';
import SignUpForm1 from './forms/signUpForm1';
import OwnerForm2 from './forms/ownerForm2';
import OwnerForm3 from './forms/ownerForm3';
import VerifyOTPForm from './forms/generic/verifyOtpForm';
import AddPhoneNumber from './forms/generic/addPhoneNumber';
import AddEmail from './forms/generic/addEmail';

import { PAGE_ROUTES } from '../../constants/pageRoutes';
import { ROLE_TYPE, ROLE_TYPE_NAME } from '../../constants/roles';
import CompleteProfile from './forms/generic/CompleteProfile';

const mapStateToProps = state => ({
  global: state.Global
});

class Registration extends PureComponent {
  constructor(props) {
    super(props);

    this.shouldMoveBackToDashboard = this.shouldMoveBackToDashboard.bind(this);
    this.isOwnerFinishingSignupProcess = this.isOwnerFinishingSignupProcess.bind(this);
  }

  isOwnerFinishingSignupProcess = () => {
    const { history } = this.props;

    const { pathname } = history.location;
    return [
      PAGE_ROUTES.OWNER_SIGN_UP_2,
      PAGE_ROUTES.OWNER_SIGN_UP_3,
      PAGE_ROUTES.COMPLETE_PROFILE
    ].includes(pathname);
  }

  isRenterFinishingSignupProcess = () => {
    const { history } = this.props;

    const { pathname } = history.location;
    return [
      PAGE_ROUTES.RENTER_SIGN_UP_2,
      PAGE_ROUTES.RENTER_SIGN_UP_3,
      PAGE_ROUTES.COMPLETE_PROFILE
    ].includes(pathname);
  }

  shouldMoveBackToDashboard = () => {
    const { global } = this.props;

    return global.userId && !this.isOwnerFinishingSignupProcess() && !this.isRenterFinishingSignupProcess();
  }

  componentWillMount() {
    let { history } = this.props;

    if (this.shouldMoveBackToDashboard()) {
      history.push(PAGE_ROUTES.DASHBOARD);
    }
  }

  render() {
    return (
      <div className='sign-up-container'>
        <Route exact path={PAGE_ROUTES.CREATE_ACCOUNT} render={() => {
          return (<CreateAccount />)
        }} />
        <Route exact path={PAGE_ROUTES.COMPLETE_PROFILE} render={() => {
          return (
            <CompleteProfile />)
        }} />
        <Route exact path={PAGE_ROUTES.RENTER_SIGN_UP_1} render={() => {
          return (
            <SignUpForm1 userType={ROLE_TYPE.renter} roleTitle={ROLE_TYPE_NAME.renter} />)
        }} />
        <Route exact path={PAGE_ROUTES.RENTER_SIGN_UP_2} render={() => { return (<OwnerForm2 userType="renter" />) }} />
        <Route exact path={PAGE_ROUTES.RENTER_SIGN_UP_3} render={() => { return (<OwnerForm3 userType="renter" />) }} />
        <Route exact path={PAGE_ROUTES.OWNER_SIGN_UP_1} render={() => {
          return (
            <SignUpForm1 userType={ROLE_TYPE.owner} roleTitle={ROLE_TYPE_NAME.owner} />)
        }} />
        <Route exact path={PAGE_ROUTES.OWNER_SIGN_UP_2} render={() => { return (<OwnerForm2 userType="owner" />) }} />
        <Route exact path={PAGE_ROUTES.OWNER_SIGN_UP_3} render={() => { return (<OwnerForm3 userType="owner" />) }} />
        <Route exact path={PAGE_ROUTES.VERIFY_OTP} render={() => { return (<VerifyOTPForm />) }} />
        <Route exact path={PAGE_ROUTES.ADD_PHONE_NUMBER} render={() => { return (<AddPhoneNumber />) }} />
        <Route exact path={PAGE_ROUTES.ADD_EMAIL} render={() => { return (<AddEmail />) }} />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(Registration));
